import useAuthStore from '../store/authStore';

export function usePermissao() {
  const nivel = useAuthStore((s) => s.nivel);
  const permissoes = useAuthStore((s) => s.permissoes);

  return {
    nivel,
    pode: (acao) => nivel === 5 || Boolean(permissoes[acao]),
  };
}
